import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { GetDetailProject, ProjectSelectChange } from "../../api/projectapi";
import ListSearchSection from "../../components/ListSearchSection/ListSearchSection";
import PostListSection from "../../components/PostListSection/PostListSection";
import { ProjectBasicDataType } from "../../interface/interface";
import { LoadingChange, ToastChange } from "../../reducers/config";
import { formatPaymentFailure } from "../../lib/paymentFailure";

type Loc = {
  pathname: string;
  state: {
    prjt_id: string;
  };
};

type Path = "mtup" | "prjt";

const csvHeader = [
  "유저넘버",
  "아이디",
  "닉네임",
  "실명",
  "번호",
  "이메일",
  "신청분야",
  "신청현황",
];

const FinishProjectList = () => {
  const dispatch = useDispatch();
  const location = useLocation() as Loc;
  const category = location.pathname.split("/")[1] as Path;
  const [data, setdata] = useState([]);
  const [prjtData, setPrjtData] = useState<ProjectBasicDataType | undefined>(
    undefined
  );

  const GetData = useCallback(() => {
    if (location.state.prjt_id) {
      GetDetailProject(location.state.prjt_id).then(({ state, data }) => {
        if (state) {
          setPrjtData(data);
          const form = data.rcrt_apply_lst.map((item: any) => {
            return Object.assign({ prjt_sts_cd: data.prjt_sts_cd }, item);
          });
          setdata(form);
        }
      });
    }
  }, [location]);

  const __ChangeState = useCallback(
    (type: "reject" | "select" | "block" | "reselect", data: any) => {
      dispatch(LoadingChange(true));
      const { prjt_id, rcrt_id, apply_id } = data;
      return ProjectSelectChange(prjt_id, rcrt_id, apply_id, type).then(
        ({ state, msg }) => {
          if (!state) {
            const reason = formatPaymentFailure(msg || "요청에 실패했습니다. 다시 시도해주세요.");
            dispatch(ToastChange({ active: true, content: reason }));
          }
          GetData();
          return state;
        }
      ).catch((error) => {
        const reason = formatPaymentFailure(error.response?.data?.err_msg || "서버와 연결하지 못했습니다. 다시 시도해주세요.");
        dispatch(ToastChange({ active: true, content: reason }));
        return false;
      }).finally(() => dispatch(LoadingChange(false)));
    },
    [dispatch, GetData]
  );

  const CsvUserData = useCallback((): Promise<any[]> => {
    return new Promise((resolve) => {
      if (!prjtData) {
        resolve([]);
        return;
      }
      resolve(
        prjtData.rcrt_apply_lst.map(
          ({
            apply_usr_nm,
            apply_usr_id,
            login_id,
            rcrt_nm,
            rcrt_usr_name,
            rcrt_usr_phone,
            usr_email,
            apply_sts_nm,
          }) => {
            return [
              apply_usr_id,
              login_id,
              apply_usr_nm,
              rcrt_usr_name,
              rcrt_usr_phone,
              usr_email,
              rcrt_nm,
             apply_sts_nm,
            ];
          }
        )
      );
    });
  }, [prjtData]);

  useEffect(() => {
    GetData();
    return () => {};
  }, [GetData]);

  return (
    <main>
      <div className="wrapper">
        <ListSearchSection
          title={`팀 ${category === "prjt" ? "프로젝트" : "밋업"} 신청리스트`}
          placeholder={"신청자 검색"}
          isExel={true}
          filter={[]}
          Search={undefined}
          headers={csvHeader}
          csvData={CsvUserData}
          csvTitle={`${prjtData?.prjt_nm ?? "팀플"} 신청자 리스트`}
        />
        <PostListSection
          type="select-user"
          tags={last_layout}
          data={data}
          PostRemove={() => {}}
          ProjectPause={undefined}
          category={category}
          ChangeProjectSts={undefined}
          __ChangeState={__ChangeState}
          prjtData={prjtData}
        />
      </div>
    </main>
  );
};

export default FinishProjectList;

const last_layout = [
  {
    type: "select-user-id",
    title: "아이디",
  },
  {
    type: "select-user-email",
    title: "이메일",
  },
  {
    type: "select-user-time",
    title: "지원분야",
  },
];
